import './styles.scss';
import * as Geofence from "../../../components/Modal/components/geofence-tab";
import { TagType } from "../../../types/bucketTypes";
import { useCallback, useEffect, useState } from "react";
import assetsApi from "../../../api/assets.api";
import { Roles } from "../../../constants/roles.constants";
import { ROLES, StorageService } from "../../../services/storage_service";
import { RolesType } from "../../../types/user.type";

export default function GeofenceTab({ tagData }: { readonly tagData: TagType }) {
  const roleData = StorageService.getItem(ROLES);
  const [geofenceList, setGeofenceList] = useState<any>([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [isGuest, setIsGuest] = useState<boolean>(false);

  // Set guest state on mount
  useEffect(() => {
    if (roleData) {
      const roles: RolesType = JSON.parse(roleData as unknown as string);
      setIsGuest(roles?.role === Roles.GUEST);
    }
  }, [roleData]);


  // Fetch geofences
  const getGeofences = useCallback(async () => {
    try {
      const sessionAssetData = sessionStorage.getItem('selectedAsset');
      let assetId;
      if (sessionAssetData) {
        assetId = JSON.parse(sessionAssetData).asset_id;
      }
      if (!assetId) return;
      const asset = await assetsApi.getSingleAsset(assetId);
      setGeofenceList(asset.data.data.geofences);
    } catch (error) {
      console.error(error);
    }
  }, []);

  // Wrapper to trigger refreshKey increment
  const triggerRefresh = () => setRefreshKey((k) => k + 1);


  // Fetch geofences on mount and when refreshKey changes
  useEffect(() => {
    getGeofences();
  }, [getGeofences, refreshKey]);

  return (
    <div className="tab-body geofence-tab">
      <Geofence.GeofenceTab
        tagData={tagData}
        geofenceData={geofenceList}
        refreshList={triggerRefresh}
        isGuest={isGuest}
      />
    </div>
  );
}